"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = exports.CLIENT_TYPE = void 0;
const Common_1 = require("./Common");
const index_1 = require("../index");
var CLIENT_TYPE;
(function (CLIENT_TYPE) {
    CLIENT_TYPE["BROKER"] = "Broker";
    CLIENT_TYPE["OPERATOR"] = "Charter Operator";
    CLIENT_TYPE["SEED_BROKER"] = "Seed Broker";
    CLIENT_TYPE["SEED_OPERATOR"] = "Seed Operator";
})(CLIENT_TYPE || (exports.CLIENT_TYPE = CLIENT_TYPE = {}));
class Client extends index_1.Base {
    name = '';
    name_key = '';
    timezone = 'America/Chicago';
    theme = {};
    orderStages = [];
    address = null;
    website = '';
    metadata = {};
    config = {};
    office_hours = {};
    phone = '';
    email = '';
    agents = [];
    followers = [];
    addresses = new index_1.ChildArray();
    third_party = [];
    errors = [];
    _m = ['id', 'active', 'name', 'name_key', 'phone', 'address', 'email', 'website', 'timezone', 'theme', 'office_hours', 'metadata', 'config', 'errors'];
    constructor(data, olMap) {
        super('clients', 22);
        (0, Common_1.setObjectProperties)(this, data, olMap, Client);
        if (typeof this.config['software'] === 'string') {
            this.config['software'] = { active: true, type: this.config['software'] };
        }
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        return super.loadAll(opts, stack, p);
    }
    async toSearchJSON(opts) {
        // Client is different from others, so we don't use Base.toSearchJSON here.
        let r = this.toMinJSON(true);
        r.objectID = this._docRef?.path;
        return r;
    }
    toMiniJSON() {
        let r = { _type: 'clients', _docRef: this._docRef };
        ['id', 'name', 'phone', 'email', 'website', 'theme', 'config'].forEach(p => {
            r[p] = this[p];
        });
        return r;
    }
    async delete() {
        if (this.active) {
            throw `This client cannot be deleted!`;
        }
        else {
            return super.delete();
        }
    }
    toJSON() {
        // checkErrors(this);
        return super.toJSON();
    }
}
exports.Client = Client;
index_1.olm.clients = (ref, map) => {
    return new Client(ref, map);
};
